import { Component } from "@angular/core";

@Component({
    selector: "app-mobile-password-reset-landing-page",
    templateUrl: "./mobile-password-reset-landing-page.component.html",
    styleUrls: ["./mobile-password-reset-landing-page.component.scss"],
})
export class MobilePasswordResetLandingPageComponent {}
